module.exports = __webpack_public_path__ + "media/images/webpage/coupons/howto-card-9f539f7a3b46304be62c21776bf80eb4.webp";